module.exports = __webpack_public_path__ + "assets/img/scss_default.b5c54766.jpg";